<div class="container">
    <div class="total-container">
        <div class="first-col">
            <div class="fake-cell empty"></div>
            <div class="fake-cell">
                <fa-icon [icon]="iconCreditCard"></fa-icon>
                <strong>{{wording.total}}</strong></div>
        </div>
        <mat-table [dataSource]="dataSourceTotal">
            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef
                                 class="text title"></mat-header-cell>
                <mat-cell *matCellDef="let row" class="title text header-row">
                    <div>{{row.title}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="total">
                <mat-header-cell *matHeaderCellDef class="value total"> {{colsHeader.total}} </mat-header-cell>
                <mat-cell *matCellDef="let row;" class="value total">
                    <price-real-amount [value]="row.total.amount"
                                       [showZero]="true"
                                       [currency]="row.total.currency"
                                       type="default"></price-real-amount>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="rowEnd">
                <mat-header-cell *matHeaderCellDef class="end"></mat-header-cell>
                <mat-cell *matCellDef="let row" class="end"></mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="cols"></mat-header-row>
            <mat-row *matRowDef="let row; columns: cols"></mat-row>

        </mat-table>
    </div>

    <div class="details-container">
        <div class="first-col">
            <div class="fake-cell">
                <car-title [booking]="vehicleRentalBookingModel"></car-title>
            </div>
        </div>
        <mat-table [dataSource]="dataSourceDetails">
            <ng-container matColumnDef="title">
                <mat-cell *matCellDef="let row"
                          class="text title"
                          [class.header-row]="row | headerClass"
                          (click)="collapse(row)">
                    <div>
                        {{row.title}}

                    </div>
                    <div *ngIf="row.collapser">
                        <fa-icon [icon]="collapsed[row.collapser] ? iconAngleDown : iconAngleUp"></fa-icon>
                    </div>
                </mat-cell>
            </ng-container>


            <ng-container matColumnDef="total">
                <mat-cell *matCellDef="let row" class="value total">
                    <price-real-amount [value]="row.total?.amount"
                                       [currency]="row.total?.currency"
                                       [showZero]="true"
                                       [type]="(row | headerClass) ? 'default' : 'light'"></price-real-amount>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="rowEnd">
                <mat-cell *matCellDef="let row" class="end"></mat-cell>
            </ng-container>

            <mat-row *matRowDef="let row; columns: cols"
                     [hidden]="row.collapseGroup && collapsed[row.collapseGroup]"></mat-row>
        </mat-table>
    </div>
</div>
